module.exports = __webpack_public_path__ + "static/media/kp_logo_purple.b8cdbd36.svg";